import { createSlice } from '@reduxjs/toolkit';
import {  fetchAllTravelMedia } from './TravelThunks';

// Slice
const travelSlice = createSlice({
  name: 'travel',
  initialState: {
    fetchTravelPending: false,
    travelList: [],
    pagination:null,
    fetchTravelRejected: null,

    status: 'idle',
    error: null,
  },
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTravelMedia.pending, (state) => {
        state.fetchTravelPending = true;
        state.fetchTravelRejected = null;
      })
      .addCase(fetchAllTravelMedia.fulfilled, (state, action) => {
        state.fetchTravelPending = false;
      
        if (action.payload?.pagination?.page==1) {
          state.travelList = action.payload.data;
        } else {
          //console.log(action.payload.data,"action.payload.data")
          action.payload.data.forEach((item) => {
            if (!state.travelList.some(existingItem => existingItem._id === item._id)) {
              state.travelList.push(item);
            }
          });
        }
      
        state.pagination = action.payload.pagination;
      })
      
      .addCase(fetchAllTravelMedia.rejected, (state, action) => {
        state.fetchTravelPending = false;
        state.fetchTravelRejected = action.payload;
      })
      
  },
});

export const {  } = travelSlice.actions;

export default travelSlice.reducer;
